<su-headline h="h1" skin="primary">{{
  'menu.tickets_tasks.component.tickets' | translate
}}</su-headline>

<div class="row-chips">
  <su-chip [items]="chips" (onRemove)="handleOnRemoveChip($event)"></su-chip>
</div>

<div style="justify-self: flex-end">
  <su-button
    skin="secondary"
    icon="file-excel"
    [label]="'Excel Download'"
    (onClick)="exportToExcel()"
    [disabled]="!canDownload">
  </su-button>
</div>

<ng-template #toolbarTpl>
  <div class="ticket-option-wrapper">
    <div class="ticket-view-container">
      <mat-form-field appearance="outline">
        <mat-label>{{ 'taskmodule.shared.label__view' | translate }}</mat-label>
        <mat-select
          [formControl]="ticketViewControl"
          (selectionChange)="onTicketViewSelectionChange()">
          <mat-option
            *ngFor="let option of ticketViewOptions"
            [value]="option.id">
            {{ option.name }}
          </mat-option>
        </mat-select>
      </mat-form-field>
    </div>
    <div class="ticket-task-select-container">
      <mat-form-field appearance="outline">
        <mat-label>{{
          'taskmodule.shared.label__ticketTaskSelection' | translate
        }}</mat-label>
        <mat-select
          [formControl]="ticketTaskControl"
          (selectionChange)="onTicketTaskSelectionChange()">
          <mat-option
            *ngFor="let option of ticketTaskOptions"
            [value]="option.value">
            {{ option.label }}
          </mat-option>
        </mat-select>
      </mat-form-field>
    </div>
  </div>

  <su-slot-controls
    [mainTLabel]="'crud.filter' | translate"
    [buttons]="controlButtons"
    [chips]="chips"
    [menuItems]="menuItems"
    [dialogData]="dialogData"
    (onCloseDialog)="onCloseDialog($event)"
    [modal]="modalComponent"></su-slot-controls>
</ng-template>

<mtx-grid
  [columnResizable]="true"
  [columns]="columns"
  [data]="data.items"
  [length]="data.totalCount"
  [pageOnFront]="false"
  [sortOnFront]="config.grid.filter.sortOnFront"
  [loading]="isLoading"
  [rowStriped]="true"
  [noResultText]="'grid.no_results' | translate"
  (rowClick)="clickRowWrapper($event)"
  [rowHover]="false"
  [cellSelectable]="false"
  [pageSizeOptions]="[5, 10, 25, 50, 100]"
  (sortChange)="sortChange($event)"
  (page)="getNextPage($event)"
  [pageSize]="config.grid.paging.pageSize"
  [pageIndex]="config.grid.paging.pageIndex"
  [showPaginator]="config.grid.paging.showPaginator"
  [columnMenuButtonText]="'grid.columns_shown' | translate"
  [columnHideable]="true"
  [columnHideableChecked]="'show' | translate"
  columnMenuButtonClass="col-button"
  [showSidebar]="true"
  [expandable]="true"
  [expansionTemplate]="expansionTemplate"
  [showToolbar]="true"
  [columnSortable]="true"
  [showColumnMenuButton]="true"
  columnMenuButtonType="flat"
  [columnPinnable]="false"
  [toolbarTemplate]="toolbarTpl"
  (columnChange)="columnsChanged($event)">
</mtx-grid>

<ng-template #expansionTemplate let-row>
  <div *ngFor="let task of getFilteredTasks(row.tasks)">
    <div class="expansion-item">
      <div>
        <ng-container>
          <p
            *ngIf="
              (task.isActive && task.subject === TaskSubject.TICKET_CLOSURE) ||
                (isOPLExt &&
                  task.isActive &&
                  task.subject ===
                    TaskSubject.OPL_EXT_EVALUATE_OFFERS_AND_CREATE_SUPPLIERS);
              else first
            "
            class="enabled space-row"
            role="button"
            tabindex="0"
            [attr.aria-label]="'Aufgabe öffnen: ' + task.subject"
            (click)="clickExpandedRow(task)"
            (keydown.enter)="clickExpandedRow(task)"
            (keydown.space)="clickExpandedRow(task); $event.preventDefault()">
            {{ task.subject }} ({{ task.status }})
          </p>
        </ng-container>
        <ng-template #first>
          <p class="disabled space-row">
            {{ task.subject }} ({{ task.status }})
          </p>
        </ng-template>
      </div>
    </div>
  </div>
</ng-template>

<ng-template #ticketActionsTemplate let-row let-index="index" let-col="colDef">
  <su-button
    [skin]="row.hasDocuments ? 'primary' : 'secondary'"
    icon="paperclip"
    (onClick)="openDocuments($event, row)"
    [title]="'documents.title' | translate"
    [ariaLabel]="'documents.title' | translate">
  </su-button>
</ng-template>

<app-spinner-overlay [show]="loading" label=""></app-spinner-overlay>
